import React, { useState } from 'react';
import { changePassword } from '../../api';

function ChangePasswordDialog({ user, onSave, onCancel }) {
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: ''
  });
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPasswords, setShowPasswords] = useState({
    current: false,
    new: false,
    confirm: false
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Fehler zurücksetzen wenn Benutzer tippt
    if (error) {
      setError('');
    }
  };

  const togglePasswordVisibility = (field) => {
    setShowPasswords(prev => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    // Validierung
    if (!formData.currentPassword) {
      setError('Bitte geben Sie Ihr aktuelles Passwort ein.');
      return;
    }
    
    if (!formData.newPassword) {
      setError('Bitte geben Sie ein neues Passwort ein.');
      return;
    }
    
    if (formData.newPassword.length < 6) {
      setError('Das neue Passwort muss mindestens 6 Zeichen lang sein.');
      return;
    }
    
    if (formData.newPassword !== formData.confirmNewPassword) {
      setError('Die neuen Passwörter stimmen nicht überein.');
      return;
    }
    
    if (formData.currentPassword === formData.newPassword) {
      setError('Das neue Passwort muss sich vom aktuellen Passwort unterscheiden.');
      return;
    }
    
    setLoading(true);
    
    try {
      const response = await changePassword(
        user.id, 
        formData.currentPassword, 
        formData.newPassword
      );
      
      if (response.success) {
        onSave(response.message || 'Passwort erfolgreich geändert');
      } else {
        setError(response.error || 'Fehler beim Ändern des Passworts');
      }
    } catch (err) {
      setError('Netzwerkfehler: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-dialog" style={{ maxWidth: '450px' }}>
        <h3>Passwort ändern</h3>
        
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit}>
          {/* Aktuelles Passwort */}
          <div className="form-group">
            <label>Aktuelles Passwort*</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPasswords.current ? 'text' : 'password'}
                name="currentPassword"
                value={formData.currentPassword}
                onChange={handleChange}
                placeholder="Ihr aktuelles Passwort"
                required
                style={{ paddingRight: '45px' }}
              />
              <button
                type="button"
                onClick={() => togglePasswordVisibility('current')}
                className="password-toggle-button"
              >
                {showPasswords.current ? (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                    <line x1="1" y1="1" x2="23" y2="23"/>
                  </svg>
                ) : (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                )}
              </button>
            </div>
          </div>
          
          {/* Neues Passwort */}
          <div className="form-group">
            <label>Neues Passwort*</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPasswords.new ? 'text' : 'password'}
                name="newPassword"
                value={formData.newPassword}
                onChange={handleChange}
                placeholder="Ihr neues Passwort (mindestens 6 Zeichen)"
                required
                style={{ paddingRight: '45px' }}
              />
              <button
                type="button"
                onClick={() => togglePasswordVisibility('new')}
                className="password-toggle-button"
              >
                {showPasswords.new ? (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                    <line x1="1" y1="1" x2="23" y2="23"/>
                  </svg>
                ) : (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                )}
              </button>
            </div>
            {formData.newPassword && formData.newPassword.length < 6 && (
              <div style={{ fontSize: '0.8rem', color: '#e53e3e', marginTop: '4px' }}>
                Das Passwort muss mindestens 6 Zeichen lang sein
              </div>
            )}
          </div>
          
          {/* Neues Passwort bestätigen */}
          <div className="form-group">
            <label>Neues Passwort bestätigen*</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPasswords.confirm ? 'text' : 'password'}
                name="confirmNewPassword"
                value={formData.confirmNewPassword}
                onChange={handleChange}
                placeholder="Neues Passwort wiederholen"
                required
                style={{ paddingRight: '45px' }}
              />
              <button
                type="button"
                onClick={() => togglePasswordVisibility('confirm')}
                className="password-toggle-button"
              >
                {showPasswords.confirm ? (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                    <line x1="1" y1="1" x2="23" y2="23"/>
                  </svg>
                ) : (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                )}
              </button>
            </div>
            {formData.confirmNewPassword && 
             formData.newPassword && 
             formData.confirmNewPassword !== formData.newPassword && (
              <div style={{ fontSize: '0.8rem', color: '#e53e3e', marginTop: '4px' }}>
                Die Passwörter stimmen nicht überein
              </div>
            )}
          </div>
          
          {/* Passwort-Stärke Indikator */}
          {formData.newPassword && (
            <div style={{ marginBottom: '15px' }}>
              <div style={{ fontSize: '0.8rem', color: '#4a5568', marginBottom: '5px' }}>
                Passwort-Stärke:
              </div>
              <div style={{ 
                height: '4px', 
                backgroundColor: '#e2e8f0', 
                borderRadius: '2px',
                overflow: 'hidden'
              }}>
                <div style={{
                  height: '100%',
                  backgroundColor: formData.newPassword.length >= 8 ? '#38a169' : 
                                  formData.newPassword.length >= 6 ? '#ed8936' : '#e53e3e',
                  width: `${Math.min((formData.newPassword.length / 8) * 100, 100)}%`,
                  transition: 'all 0.3s ease'
                }} />
              </div>
              <div style={{ fontSize: '0.7rem', color: '#718096', marginTop: '2px' }}>
                {formData.newPassword.length >= 8 ? 'Stark' :
                 formData.newPassword.length >= 6 ? 'Mittel' : 'Schwach'}
              </div>
            </div>
          )}
          
          <div className="modal-actions">
            <button 
              type="button" 
              onClick={onCancel} 
              className="cancel-button"
              disabled={loading}
            >
              Abbrechen
            </button>
            <button 
              type="submit" 
              disabled={
                loading || 
                !formData.currentPassword || 
                !formData.newPassword || 
                !formData.confirmNewPassword ||
                formData.newPassword !== formData.confirmNewPassword ||
                formData.newPassword.length < 6
              }
            >
              {loading ? 'Wird geändert...' : 'Passwort ändern'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ChangePasswordDialog;